import { notification } from "antd";
import axiosInstance from "../axiosInstance";
import { Persona } from "../../pages/Enterprise/modules/Persona/types";

const getPersona = async (
  id: string,
  mainAccountId?: string
): Promise<Persona> => {
  try {
    const response = await axiosInstance.get<Persona>(`/persona/${id}`, {
      params: { mainAccountId },
    });
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível retornar a Persona.",
    });

    throw new Error(`${error}`);
  }
};

const deletePersona = async (
  id: string,
  mainAccountId?: string
): Promise<Persona> => {
  try {
    const response = await axiosInstance.delete<Persona>(`/persona/${id}`, {
      params: { mainAccountId },
    });
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível deletar a Persona.",
    });

    throw new Error(`${error}`);
  }
};

const createPersona = async (
  id: string,
  data: Persona,
  mainAccountId?: string
): Promise<Persona> => {
  try {
    const queryParams = mainAccountId ? `?mainAccountId=${mainAccountId}` : "";
    const response = await axiosInstance.post<Persona>(
      `/persona/${id}${queryParams}`,
      data
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível criar a Persona.",
    });

    throw new Error(`${error}`);
  }
};

export const personaService = {
  getPersona,
  createPersona,
  deletePersona,
};
